import { render, staticRenderFns } from "./AxisRetentionGlobalDialog.vue?vue&type=template&id=03dc05c0"
import script from "./AxisRetentionGlobalDialog.vue?vue&type=script&lang=js"
export * from "./AxisRetentionGlobalDialog.vue?vue&type=script&lang=js"
import style0 from "./AxisRetentionGlobalDialog.vue?vue&type=style&index=0&id=03dc05c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports